import {
  DesignOptions, DesignSwatches, EnabledDesigns, designOptionsConfig,
} from './constants';

const updateCustomisationOptions = (selectedDesign: string) => {
  const config = designOptionsConfig[selectedDesign];
  const customTextInput: HTMLInputElement = document.querySelector('.js-engraving-custom-text');
  const customTextInput2: HTMLInputElement = document.querySelector('.js-engraving-custom-text-2');
  const datePickerInput: HTMLInputElement = document.querySelector('.js-engraving-date-picker');
  const customOptionsWrapper: HTMLElement = document.querySelector('.js-engraving-custom-options');

  customOptionsWrapper.dataset.selectedDesign = selectedDesign;

  if (config === DesignOptions.DATE_AND_TEXT) {
    customOptionsWrapper.classList.remove('hidden');
    customTextInput.classList.remove('hidden');
    customTextInput2.classList.add('hidden');
    datePickerInput.classList.remove('hidden');
  } else if (config === DesignOptions.DATE_ONLY) {
    customOptionsWrapper.classList.remove('hidden');
    customTextInput.classList.add('hidden');
    customTextInput2.classList.add('hidden');
    datePickerInput.classList.remove('hidden');
  } else if (config === DesignOptions.CUSTOM) {
    customOptionsWrapper.classList.remove('hidden');
    customTextInput.classList.remove('hidden');
    customTextInput2.classList.remove('hidden');
    datePickerInput.classList.remove('hidden');
  } else if (config === DesignOptions.NONE) {
    customTextInput.value = '';
    customTextInput2.value = '';
    datePickerInput.value = '';

    customOptionsWrapper.classList.add('hidden');
    customTextInput.classList.add('hidden');
    customTextInput2.classList.add('hidden');
    datePickerInput.classList.add('hidden');
  }
};

const handleAddToCart = (e: Event) => {
  e.preventDefault();
  e.stopPropagation();

  const customTextInput = document.querySelector('.js-engraving-custom-text');
  const customTextInput2 = document.querySelector('.js-engraving-custom-text-2');
  const designInputCtr = document.querySelector('input[name="design-option"]:checked');
  const dateInputCtr = document.querySelector('.js-engraving-date-picker') as HTMLInputElement;
  const potColorInputCtr = document.querySelector('input[name="engraving-color"]:checked') as HTMLInputElement;

  const engravingDesign = (designInputCtr as HTMLInputElement).value;
  const customTextFirstLine = (customTextInput as HTMLInputElement).value;
  const customTextSecondLine = (customTextInput2 as HTMLInputElement).value;

  const customEngravingAttributes: Record<string, unknown> = {};
  const allowedDesignOption = designOptionsConfig[engravingDesign];

  if (allowedDesignOption === DesignOptions.DATE_ONLY) {
    customEngravingAttributes.customDate = dateInputCtr.value;
  } else if (allowedDesignOption === DesignOptions.DATE_AND_TEXT) {
    customEngravingAttributes.customText = customTextFirstLine;
    customEngravingAttributes.customDate = dateInputCtr.value;
  } else if (allowedDesignOption === DesignOptions.CUSTOM) {
    customEngravingAttributes.customText = customTextFirstLine;
    customEngravingAttributes.customText2 = customTextSecondLine;
    customEngravingAttributes.customDate = dateInputCtr.value;
  }

  document.dispatchEvent(new CustomEvent('add-to-cart-visualizer', {
    detail: {
      engravingDesign,
      ...(potColorInputCtr ? { potColor: potColorInputCtr.value } : {}),
      ...customEngravingAttributes,
      quantity: 1,
    },
  }));
};

const initDesignOptions = () => {
  const engravingDesignOptionsEl = document.querySelector('.js-engraving-design-options');

  if (!engravingDesignOptionsEl) {
    return;
  }

  let markup = '';

  EnabledDesigns.forEach((design) => {
    const swatch = DesignSwatches[design];

    markup += `
      <div class="engraving-design-option">
        <input type="radio" name="design-option" id="${design}" value="${design}">
        <label for="${design}">
          <img src="${swatch}" />
        </label>
      </div>
    `;
  });

  engravingDesignOptionsEl.innerHTML = markup;

  // Select first design
  const firstDesignInput: HTMLInputElement = engravingDesignOptionsEl.querySelector('input[name="design-option"]');
  firstDesignInput.checked = true;
};

export {
  initDesignOptions,
  updateCustomisationOptions,
  handleAddToCart,
};
